import { style } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild, TemplateRef, Renderer2, AfterViewInit, inject } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminServices, GlobalService } from '@app/services';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as xml2js from 'xml2js';
import { salesforceUrl } from '@app/helpers/salesforce';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');

interface invoice {
  uuid: string;
  request_id: number | null;
  amount_preapproved: number;
  amount: number;
  exchange_rate: number | 0;
}

@Component({
  selector: 'app-factoring-requests',
  templateUrl: './factoring-requests.component.html',
  styleUrls: ['./factoring-requests.component.scss'],
  standalone: false
})
export class FactoringRequestsComponent implements OnInit, AfterViewInit {

  @ViewChild('confirmationModalSendData') confirmationModalSend!: TemplateRef<any>;
  @ViewChild('confirmationModalConversion') confirmationModal!: TemplateRef<any>;
  @ViewChild('inputFileElement') inputFileElement!: ElementRef
  @ViewChild('dropArea', { static: false }) dropArea!: ElementRef


  public formParent: UntypedFormGroup = new UntypedFormGroup({});
  nameFetched: string = '';
  nameCreditLineFetched: string = '';
  listAccounts: Array<any> = []
  listCreditLine: Array<any> = []
  accountSelected: any = null;
  accountIdSelected: any = null;
  creditLineSelected: any = null;
  // fondeo Nafin: valida que la cuenta tenga Clave SIRAC
  fundedByNafin: boolean = false;
  accountSirac: string = '';
  checkingSirac: boolean = false;
  creditLineIdSelected: any = null;
  enableAction: boolean = true;
  actionSelected: any = null;
  totalAmountBillings: number = 0
  signingFeeCharge:boolean = false

  accountsFiltered: Observable<any>;
  creditLinesFiltered: Observable<any>;
  typeCurrency: string = '';
  arrayTypeCurrency: Array<any> = [];

  enableExpirationDate: boolean = false;
  formRequest: UntypedFormGroup;
  typeProduct: any = null
  exchangeRate: any;

  currentUser: any = null;

  namesBillsCaptured: Array<any> = []
  xmlUuidFetched: Array<any> = []
  currentXml: any = null

  isEmptyListAccounts: boolean = false;
  isEmptyListCreditLines: boolean = false;
  dragOver: boolean = false;

  allBillsOk: boolean = true
  billsOutOfDate: Array<any> = []

  creditLinesByAccount: Array<any> = []

  minDatePicker: any = null;
  maxDatePicker: any = null;

  allowMultipleFiles: boolean = true;
  selectedFiles: Array<any> = []

  confirmationSendMessage: any = '';

  invoicesData: invoice[] = [];
  totalsOnInvoices: any = {
    amount_preapproved: 0,
    amount: 0,
    amount_preapproved_with_commissions: 0,
    amount_signing_fee: 0,
    amount_drawdown_fee: 0
  };
  opportunityData: any = null;


  // Variables for the sidebar of calculators

  showCalculator: boolean = true;

  overcollateralForCalculator: number = 0;
  invoiceAmountForCalculator: number = 0;
  calculatedPreapprovedAmount: number = 0;

  startDate: string = '';
  daysToAdd: number | null = null;
  resultDate: string | null = null;
  selectTab: string = 'amount_preapproved'
  errorsValidateInvoices: any = [];
  errorsValidateInvoicesDb: any = [];
  holidaysData: Array<any> = []

  // USD → MXN aforo calculator
  invoiceAmountUSDCalc: number = 0;
  exchangeRateCalc: number = 0;
  preapprovedAmountMXNCalc: number = 0;
  invoiceAmountConvertedMXN: number = 0;
  calculatedAforoUSD: number = 0;

  // Permission Access - Only users with the correct permissions will be able to see the factoring requests module
  permissionAccess: boolean = false;
  partners:any[] = []
  partnerSelected:any = null

  amountCommissionDisbursement:number = 0;
  amountCommissionOpening:number = 0;
  newAmountPreapprovedWithComissions:number = 0;
  newAmountCommissionDisursement:number = 0;
  newAmountComissionOpening:number = 0;
  constructor(
    private adminService: AdminServices,
    private global: GlobalService,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private renderer2: Renderer2
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

  }

  formInformationRequest = new UntypedFormGroup({
    account_id: new UntypedFormControl('', Validators.required),
    account_name: new UntypedFormControl('', Validators.required),
    credit_line_id: new UntypedFormControl('', Validators.required),
    credit_line_name: new UntypedFormControl('', Validators.required),
    opportunity_name: new UntypedFormControl('', Validators.required),
  });

  ngOnInit(): void {
    this.initFormParent();
    this.adminService.getAllProviders().subscribe((result)=>{
      if(!result.error){
        this.partners = result.data
        if(this.partners){
          this.partners = this.partners.filter((e)=> e.product_type === 2 || e.product_type == 3);
        }
      }
    })
    this.getExchangeRate();
    this.formRequest = this.formBuilder.group({
      account_id: [null, [Validators.required]],
      account_name: [null, [Validators.required]],
      credit_line_id: [null, [Validators.required]],
      credit_line_name: [null, [Validators.required]],
    })

    this.accountsFiltered = this.formRequest.controls['account_name'].valueChanges.pipe(
      startWith(''),
      map(val => {
        if (this.accountSelected && this.accountSelected.name !== val) {
          this.accountSelected = null;
          this.creditLineSelected = null;
          this.creditLineIdSelected = null;
          this.creditLinesByAccount = [];
        }
        return this.filterAccounts(val);
      })
    );
    this.creditLinesFiltered = this.formRequest.controls['credit_line_name'].valueChanges.pipe(
      startWith(''),
      map(val => this.filterCreditLines(val))
    );

    this.setHolidays()

    this.verifyPermissionAccess();

  }

  verifyPermissionAccess() {
    try {
      const permissions = JSON.parse(localStorage.getItem('modulesPermission')) || [];
      this.permissionAccess = permissions.includes('factoring_requests');
    } catch {
      this.permissionAccess = false;
    }
  }

  ngAfterViewInit(): void {
    this.initListenersDrag()
  }
  async setHolidays() {
    let holidaysFetched = await this.adminService.getHolidays().toPromise();
    if (!holidaysFetched.error) {
      for (let holiday of holidaysFetched.data) {
        this.holidaysData.push(moment(holiday))
      }
    } else {
      console.log('error getting holidays: ' + holidaysFetched.message)
    }
  }

  dateFilter = (date: any): boolean => {
    if (!date) return false;
    let currentDate = moment(date)

    // excluir feriados
    return !this.holidaysData.some(f =>
      f.isSame(currentDate, 'day')
    );
  };


  initListenersDrag() {
    this.listenerDragOver()
    this.listenerDragLeave()
    this.listenDrop();
  }

  initFormParent() {
    this.formParent = new UntypedFormGroup({
      xml_list: new UntypedFormArray([new UntypedFormGroup({
        'xml_data_file': new UntypedFormControl(null, [Validators.required]),
        'xml_data_url': new UntypedFormControl(null, [Validators.required]),
        'xml_data_raw': new UntypedFormControl(null, [Validators.required]),
        'xml_id': new UntypedFormControl(null, [Validators.required]),
        'xml_uuid': new UntypedFormControl(null, [Validators.required]),
        'amount_bill': new UntypedFormControl(null, [Validators.required]),
      }
      )])
    })
  }

  // en el filtrado, sera mejor hacer la busqueda de lso codigos postales
  private filterAccounts(val: any): any {
    const formatedVal = val;
    return this.listAccounts.filter((item) => item.name.toLowerCase().includes(formatedVal.toLowerCase()))
  }

  private filterCreditLines(val: any): any {
    const formatedVal = val;
    return this.listCreditLine.filter((item) => item.name.includes(formatedVal));
  }

  get getXml() {
    return <UntypedFormArray>this.formParent.controls['xml_list']
  }

  // SI SE USA
  addXml() {
    this.getXml.push(new UntypedFormGroup({
      'xml_data_file': new UntypedFormControl(null, [Validators.required]),
      // 'xml_data_url': new FormControl(null, [Validators.required]),
      'xml_data_raw': new UntypedFormControl(null, [Validators.required]),
      'xml_name_file': new UntypedFormControl(null, [Validators.required]),
      'xml_id': new UntypedFormControl(null, [Validators.required]),
      'xml_uuid': new UntypedFormControl(null, [Validators.required]),
      'amount_bill': new UntypedFormControl(null, [Validators.required]),
      'date_bill': new UntypedFormControl(null, [Validators.required]),
    }
    ));
  }

  searchAccounts(typeProduct:any, partnerCode:string) {
    this.listAccounts = []
    this.adminService.getAccounts(null, '', typeProduct, partnerCode).subscribe((response) => {
      if (!response.error) {
        if (response.data.length > 0) {
          this.isEmptyListAccounts = false;
          this.listAccounts = response.data;
        } else {
          this.isEmptyListAccounts = true;
          this.listAccounts = []
        }
      } else {
        this.global.prepareAlert({ title: "Error in service getAccounts", message: "contact support...", label: "warn" }).subscribe((result) => { });
      }
    });
  }

  deleteBilling(index: number) {
    this.getXml.removeAt(index);
    this.xmlUuidFetched.splice(index, 1)
    this.selectedFiles.splice(index, 1);
    this.arrayTypeCurrency.splice(index, 1);
    this.invoicesData.splice(index, 1);

    this.totalAmountBillings = Number((this.selectedFiles.reduce((init, invoice) => init + invoice.totalInvoice, 0)).toFixed(2));
  }

  async save() {

    // fondeo Nafin: la cuenta debe tener Clave SIRAC
    if (this.fundedByNafin && !this.accountSirac) {
      this.global.prepareAlert({ title: "Falta Clave SIRAC", message: "La cuenta no tiene Clave SIRAC en Salesforce; no se puede proceder con fondeo Nafin.", label: "warn" }).subscribe((result) => { });
      return
    }

    if (this.creditLineSelected.overcollateral > 1) {
      this.global.prepareAlert({ title: "Campos incompletos", message: "Aforo incorrecto", label: "warn" }).subscribe((result) => { });
      return
    }

    if (this.totalAmountBillings > 0) {
      // elimina el primer item del array que esta vacio ya que se inicializo con uno vacio
      if (this.accountSelected && this.creditLineSelected) {
        for (let item of this.formParent.controls['xml_list'].value) {
          if (!item.xml_name_file) {
            let currentIndexDelete = this.formParent.controls['xml_list'].value.indexOf(item);
            this.getXml.removeAt(currentIndexDelete)

          }
        }
        let verifyBillArray = [];
        // verify billings
        for (let item of this.formParent.controls['xml_list'].value) {
          verifyBillArray.push({
            "xml_uuid": item.xml_uuid,
            "date_bill_fetched": item.date_bill,
            "max_date": moment(item.date_bill).add(this.creditLineSelected.maximum_term, 'days').format('YYYY-MM-DD'),
            "min_date": moment(item.date_bill).add(this.creditLineSelected.minimum_term, 'days').format('YYYY-MM-DD'),
          });
        }
        this.billsOutOfDate = []
        this.allBillsOk = true;
        let diff = 0
        let expirationDaySelected = null;
        if (this.enableExpirationDate) {
          if (this.creditLineSelected.expiration_date && this.enableExpirationDate) {
            expirationDaySelected = this.creditLineSelected.expiration_date
          } else {
            expirationDaySelected = moment().add(this.creditLineSelected.maximum_term, 'days').format('YYYY-MM-DD');
          }
          for (let currentBill of verifyBillArray) {
            if (!moment(expirationDaySelected).isSameOrAfter(moment(currentBill.min_date)) || !moment(expirationDaySelected).isSameOrBefore(moment(currentBill.max_date))) {
              this.billsOutOfDate.push(currentBill);
              this.allBillsOk = false;
            }
          }

          diff = (moment(expirationDaySelected).diff(moment().utc(), 'days')) + 1
        } else {
          diff = this.creditLineSelected.maximum_term;
        }
        if (this.allBillsOk) {
          let data: any = {
            "data_request": {
              "account": this.accountSelected,
              "credit_line": this.creditLineSelected
            },
            "data_billings": this.formParent.controls['xml_list'].value,
            "total_amount_billings": Number(this.totalAmountBillings.toFixed(2)),
            'over_collateral': this.creditLineSelected.overcollateral,
            "user": this.currentUser,
            "conversion_usd": false,
            "diff_term": diff
          }
          if ((!this.arrayTypeCurrency.every(value => value === this.arrayTypeCurrency[0]))) {
            this.global.prepareAlert({ title: "Warning", message: "Las facturas deben ser de un mismo tipo de 'Currency'. Elimine las diferentes.", label: "error" }).subscribe((result) => { });
            return;
          } else {
            data.type_currency = this.arrayTypeCurrency[0];
            if (data.type_currency === 'USD') {
              await this.modalConfirmConversion().then(result => {
                data.conversion_usd = result;
                this.openConfirmationModal(data);
              });

            } else {
              this.openConfirmationModal(data);
            }
          }
        }
      } else {
        this.global.prepareAlert({ title: "Campos incompletos", message: "Falta seleccionar cuenta o linea de credito", label: "warn" }).subscribe((result) => { });
      }
    } else {
      this.global.prepareAlert({ title: "Sin monto a facturar", message: "Ingrese xml (numero minimo de xmls aceptable: 1)", label: "warn" }).subscribe((result) => { });
    }

  }

  openConfirmationModal(data: any) {
    this.opportunityData = data;

    // calculate amount_preapproved for all invoices
    this.invoicesData.map((invoice) => {
      invoice.amount_preapproved = invoice.amount - (invoice.amount * this.creditLineSelected.overcollateral)
      invoice.exchange_rate = data.type_currency === 'USD' ? this.exchangeRate.value : 1; // modificar cuando ya se puedan subir facturas de ambas monedas
      return invoice;
    });

    this.totalsOnInvoices = {
      amount_preapproved: this.invoicesData.reduce((sum, invoice) => sum + invoice.amount_preapproved, 0).toFixed(2),
      amount: this.invoicesData.reduce((sum, invoice) => sum + invoice.amount, 0).toFixed(2)
    };
    if(this.totalsOnInvoices.amount_preapproved){
      
      this.totalsOnInvoices.amount_signing_fee = +this.accountSelected.signing_fee_amount.toFixed(2); // viene desde sf en mxn
      this.totalsOnInvoices.amount_signing_fee_vat = +(this.totalsOnInvoices.amount_signing_fee * 0.16).toFixed(2);
      this.totalsOnInvoices.amount_drawdown_fee = +(this.creditLineSelected.drawdown_fee * this.totalsOnInvoices.amount_preapproved).toFixed(3);
      this.totalsOnInvoices.amount_drawdown_fee_vat = +(this.totalsOnInvoices.amount_drawdown_fee * 0.16).toFixed(3);

      this.totalsOnInvoices.amount_preapproved_with_commissions = this.totalsOnInvoices.amount_preapproved - (this.totalsOnInvoices.amount_drawdown_fee + this.totalsOnInvoices.amount_drawdown_fee_vat)
      this.totalsOnInvoices.amount_bill = this.totalsOnInvoices.amount
      if(this.typeCurrency != 'MXN'){
        this.totalsOnInvoices.amount_drawdown_fee = this.totalsOnInvoices.amount_drawdown_fee * this.exchangeRate.value;
        this.totalsOnInvoices.amount_drawdown_fee_vat = this.totalsOnInvoices.amount_drawdown_fee_vat * this.exchangeRate.value;
        this.totalsOnInvoices.amount_preapproved_with_commissions = this.totalsOnInvoices.amount_preapproved_with_commissions * this.exchangeRate.value;
        this.totalsOnInvoices.amount_bill = this.totalsOnInvoices.amount_bill * this.exchangeRate.value;
      }
    }  
    this.modalService.open(this.confirmationModalSend, { backdrop: 'static', keyboard: false, size: 'xl' });
  }

  sendData() {

    let data = this.opportunityData;
    data.invoices_summary = this.invoicesData;

    if (this.expirationDateOnWeekend) {
      data.diff_term = moment(this.showDateFormat).diff(moment(`${moment().format('YYYY-MM-DD')}T18:00:00Z`), 'days')
    }

    this.confirmationSendMessage = `Monto de factura: $${this.totalAmountBillings.toFixed(2)} || Aforo: %${data.over_collateral * 100} || Monto pre aprobado: $${this.totalsOnInvoices.amount_preapproved_with_commissions} || Linea de credito: ${data.data_request.credit_line.name}`;
    this.confirmationSendMessage += data.type_currency === 'USD' ? ` || Conversión de USD a MXN: ${data.conversion_usd ? 'Verdadero' : 'Falso'}` : '';
    data.signing_fee_charge = this.signingFeeCharge

    this.global.prepareModal({
      title: "Se enviara la información a procesar, ¿Esta seguro(a)?",
      message: this.confirmationSendMessage
    }).subscribe((modalResult) => {
      if (modalResult == "ok") {
        this.adminService.createOppMrpFactoring(data, 'mrpresta').subscribe((response) => {
          if (!response.error) {
            this.global.prepareAlert({ title: "Exito!!", message: 'La oportunidad se creo correctamente, seras redirigido a salesforce y se recargara la pagina...', label: "success" }).subscribe((result) => { });
            window.open(`${salesforceUrl}/lightning/r/Opportunity/${response.data.id}/view`, "_blank");
            setTimeout(() => {
              window.location.reload();
            }, 2000)
          } else {
            this.global.prepareAlert({ title: "Ocurrio un error", message: response.message, label: "error" }).subscribe((result) => { });
          }
        });

      }
    })
  }


  onChangeAccountCreditLine(value: number, type: string) {
    this.creditLinesByAccount = [];
    if (type == 'account') {
      this.accountSelected = this.listAccounts.filter((item) => item.id == value)[0]
      // cambio de cuenta: revalidar SIRAC si el fondeo Nafin esta activo
      this.accountSirac = '';
      if (this.fundedByNafin) this.checkAccountSirac();
      if (this.accountSelected.credit_lines.length > 0) {
        this.isEmptyListCreditLines = false;
        for (let creditLine of this.accountSelected.credit_lines) {
          this.creditLinesByAccount.push({
            "id": creditLine.id_credit_line,
            "name": creditLine.name_credit_line,
            "overcollateral": +(creditLine.overcollateral / 100).toFixed(2),
            "stage": creditLine.stage,
            "maximum_term": creditLine.maximum_term,
            "minimum_term": creditLine.minimum_term,
            "drawdown_fee": creditLine.drawdown_fee
          })
        }
      } else {
        this.creditLineSelected = null
        this.isEmptyListCreditLines = true;
      }
    }

  }

  onNafinToggle(): void {
    this.accountSirac = '';
    if (this.fundedByNafin && this.accountSelected) this.checkAccountSirac();
  }

  // trae la Clave SIRAC de la cuenta seleccionada
  checkAccountSirac(): void {
    if (!this.accountSelected) return;
    this.checkingSirac = true;
    this.adminService.getAccountSirac(this.accountSelected.id).subscribe({
      next: (res) => {
        this.checkingSirac = false;
        this.accountSirac = (res && res.error === false && res.data) ? (res.data.sirac || '') : '';
      },
      error: () => {
        this.checkingSirac = false;
        this.accountSirac = '';
      },
    });
  }

  showDate: any = null
  showDateFormat: any = null;
  expirationDateOnWeekend: boolean = false;
  valueExpirationDate: any = null
  selectCreditLine() {
    let currentCreditLine = this.creditLinesByAccount.filter((item) => item.id == this.creditLineIdSelected)[0];
    if (this.creditLineIdSelected) {
      this.creditLineSelected = {
        "id": currentCreditLine.id,
        "name": currentCreditLine.name,
        "overcollateral": currentCreditLine.overcollateral,
        "stage": currentCreditLine.stage,
        "expiration_date": null,
        "maximum_term": currentCreditLine.maximum_term ? currentCreditLine.maximum_term : 60,
        "minimum_term": currentCreditLine.minimum_term ? currentCreditLine.minimum_term : 30,
        "drawdown_fee": currentCreditLine.drawdown_fee,
        "drawdown_fee_with_vat": (currentCreditLine.drawdown_fee * (1 + 0.16))
      }
      // fill fields commmission calculator
      this.amountCommissionOpening = +this.accountSelected.signing_fee_amount.toFixed(2); 
      this.amountCommissionOpening += (this.amountCommissionOpening * 0.16)
      this.valueExpirationDate = moment().add(this.creditLineSelected.maximum_term, 'day'); // solo manejar fechas sin horas 
      if (this.valueExpirationDate.day() == 0 || this.valueExpirationDate.day() == 6) {
        this.expirationDateOnWeekend = true;
        this.showDate = this.valueExpirationDate.format('dddd, D [de] MMMM [de] YYYY')
        this.showDateFormat = this.valueExpirationDate.format('YYYY-MM-DD')
        this.showDateFormat += 'T18:00:00Z'
      }
      this.enableAction = false;
    } else {
      this.creditLineSelected = null
    }
  }

  redirectToSalesforce(Id: string) {
    if (Id) {
      window.open(`${salesforceUrl}/lightning/r/Credit_line__c/${Id}/view`, "_blank");
    } else {
      alert(`No se encontro id...`)
    }
  }

  openSelectFileDialog() {
    this.inputFileElement.nativeElement.value = null;
    this.inputFileElement.nativeElement.click();
  }

  onSelectFiles(evt: any) {
    let files = Array.from(evt.target.files);
    for (let file of files) {
      let currentIndex = null
      if (this.getXml.length == 1) {
        currentIndex = 0
        this.addXml();
      } else {
        this.addXml();
        currentIndex = (this.getXml.length - 1)
      }
      this.pushFilesInArray(file, currentIndex);
    }
  }

  listenerDragOver() {
    this.renderer2.listen(
      this.dropArea.nativeElement, 'dragover', (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = true;
      }
    )
  }

  listenerDragLeave() {
    this.renderer2.listen(
      this.dropArea.nativeElement, 'dragleave', (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
      }
    )
  }
  currentIndexCount: number = 0;
  listenDrop() {
    this.renderer2.listen(
      this.dropArea.nativeElement, 'drop', (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
        let files = Array.from(event?.dataTransfer.files ?? []);
        for (let file of files) {
          let currentIndex = null
          if (this.getXml.length == 1) {
            currentIndex = 0
            this.addXml();
          } else {
            this.addXml();
            currentIndex = (this.getXml.length - 1)
          }
          this.pushFilesInArray(file, currentIndex);
        }
      }
    )
  }

  onExpirationDateSelected(event: any) {
    this.creditLineSelected.expiration_date = moment(event.value).format('YYYY-MM-DD');
    this.valueExpirationDate = moment(this.creditLineSelected.expiration_date); // solo manejar fechas sin horas 
    if (this.valueExpirationDate == 0 || this.valueExpirationDate.day() == 6) {
      this.expirationDateOnWeekend = true;
      this.showDate = this.valueExpirationDate.format('dddd, D [de] MMMM [de] YYYY')
      this.showDateFormat = this.valueExpirationDate.format('YYYY-MM-DD')
      this.showDateFormat += 'T18:00:00Z'
    } else {
      this.expirationDateOnWeekend = false;
    }
  }
  dateBills: Array<any> = []
  pushFilesInArray(file: any, index: any) {
    var reader = new FileReader();
    reader.onload = (evt) => {
      var xmlData: string = (evt as any).target.result;
      const parser = new xml2js.Parser({ strict: false, trim: true });
      this.currentXml = parser.parseString(xmlData, (err, result) => {
        if (err) {
          console.log(err);
        }
        if (result) {
          if (!this.xmlUuidFetched.includes(result['CFDI:COMPROBANTE']['CFDI:COMPLEMENTO'][0]['TFD:TIMBREFISCALDIGITAL'][0]['$']['UUID'])) {

            if (result['CFDI:COMPROBANTE']['$']['TIPODECOMPROBANTE'] == 'I') {
              let uuid = result['CFDI:COMPROBANTE']['CFDI:COMPLEMENTO'][0]['TFD:TIMBREFISCALDIGITAL'][0]['$']['UUID'];
              let totalInvoiceAmount = parseFloat(result['CFDI:COMPROBANTE']['$']['TOTAL']);

              this.xmlUuidFetched.push(uuid)
              this.selectedFiles.push({
                'name': file.name,
                'index': index,
                'currency': result['CFDI:COMPROBANTE']['$']['MONEDA'],
                'totalInvoice': totalInvoiceAmount,
                'uuid': result['CFDI:COMPROBANTE']['CFDI:COMPLEMENTO'][0]['TFD:TIMBREFISCALDIGITAL'][0]['$']['UUID'],
                'rfc_emmiter': result['CFDI:COMPROBANTE']['CFDI:EMISOR'][0]['$']['RFC'],
                'rfc_reciver': result['CFDI:COMPROBANTE']['CFDI:RECEPTOR'][0]['$']['RFC'],
                'type_invoice': result['CFDI:COMPROBANTE']['$']['TIPODECOMPROBANTE'],

              })
              this.formParent.controls['xml_list'].value[index].xml_data = file;
              this.formParent.controls['xml_list'].value[index].xml_id = index;
              this.formParent.controls['xml_list'].value[index].xml_name_file = file.name;
              this.formParent.controls['xml_list'].value[index].xml_data_raw = xmlData
              this.formParent.controls['xml_list'].value[index].amount_bill = totalInvoiceAmount
              this.formParent.controls['xml_list'].value[index].date_bill = moment(result['CFDI:COMPROBANTE']['$']['FECHA']).format('YYYY-MM-DD')
              this.totalAmountBillings += totalInvoiceAmount;
              this.formParent.controls['xml_list'].value[index].xml_uuid = uuid;
              this.typeCurrency = result['CFDI:COMPROBANTE']['$']['MONEDA'];

              this.dateBills.push(result['CFDI:COMPROBANTE']['$']['FECHA'])
              this.invoicesData.push(
                {
                  uuid,
                  amount_preapproved: 0, // calculate when data is shown to the user
                  amount: totalInvoiceAmount,
                  exchange_rate: 0, // calculate also after
                  request_id: null
                }
              )

              this.arrayTypeCurrency.push(this.typeCurrency);
            } else {
              this.errorsValidateInvoices.push({ 'data': { 'uuid': result['CFDI:COMPROBANTE']['CFDI:COMPLEMENTO'][0]['TFD:TIMBREFISCALDIGITAL'][0]['$']['UUID'] }, 'estado': 'N/A', 'description': 'Factura tipo P' })
            }

          } else {
            this.global.prepareAlert({ title: "Ocurrio un error", message: "Ya ha subido esta factura anteriormente, uuid: " + result['CFDI:COMPROBANTE']['CFDI:COMPLEMENTO'][0]['TFD:TIMBREFISCALDIGITAL'][0]['$']['UUID'], label: "error" }).subscribe((result) => { });
          }
        }
      });
    };
    reader.readAsText(file);
  }

  async calculatePreapprovedAmount() {
    this.calculatedPreapprovedAmount = this.invoiceAmountForCalculator * (1 - (this.overcollateralForCalculator / 100));
  }

  calculatedOvercollateral: number = 0;
  amountPreapprovedCalculator: number = 0;
  invoiceAmountCalculatorOvercollateral: number = 0;
  async calculateOverColateral() {
    this.calculatedOvercollateral = ((1 - (this.newAmountPreapprovedWithComissions / this.invoiceAmountCalculatorOvercollateral)) * 100)
  }

  async calculateCommissions(){
    this.newAmountPreapprovedWithComissions = (this.amountPreapprovedCalculator + this.amountCommissionOpening) / (1 - (this.creditLineSelected.drawdown_fee_with_vat));
    this.amountCommissionDisbursement = (this.newAmountPreapprovedWithComissions * this.creditLineSelected.drawdown_fee_with_vat)
    this.calculateOverColateral()
  }

  async calculateUSDAforo() {
    const rate = this.exchangeRate && this.exchangeRate.value ? this.exchangeRate.value : 0;
    if (this.invoiceAmountUSDCalc > 0 && rate > 0) {
      this.invoiceAmountConvertedMXN = this.invoiceAmountUSDCalc * rate;
      if (this.preapprovedAmountMXNCalc > 0) {
        this.calculatedAforoUSD = (1 - (this.preapprovedAmountMXNCalc / this.invoiceAmountConvertedMXN)) * 100;
      }
    } else {
      this.invoiceAmountConvertedMXN = 0;
      this.calculatedAforoUSD = 0;
    }
  }

  async calculateNewDate() {
    if (this.startDate && this.daysToAdd !== null && this.daysToAdd !== undefined) {
      let initialDate = moment(this.startDate);
      this.resultDate = initialDate.add(this.daysToAdd, 'days').format('YYYY-MM-DD');
    } else {
      this.resultDate = null;
    }
  }

  async modalConfirmConversion(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const modalRef = this.modalService.open(this.confirmationModal, { backdrop: 'static', keyboard: false });
      modalRef.result.then((result) => resolve(result));
    })
  }

  getExchangeRate() {
    this.adminService.getLastTypeExchangeRate().subscribe((response) => {
      if (!response.error) {
        this.exchangeRate = response.data;
      }
    });
  }

  changeSetDate(event: any) {
    this.setMinAndMaxDates();
  }

  setMinAndMaxDates() {
    let momentsMin = this.dateBills.map(d => moment(d))
    let momentsMax = this.dateBills.map(d => moment(d))
    let currentCreditLine = this.creditLinesByAccount.filter((item) => item.id == this.creditLineIdSelected)[0]
    let minDate = moment.min(momentsMin)
    let maxDate = moment.max(momentsMax)
    this.minDatePicker = minDate.add((currentCreditLine.minimum_term + 1), 'days').format('YYYY-MM-DD')
    this.maxDatePicker = maxDate.add((currentCreditLine.maximum_term + 1), 'days').format('YYYY-MM-DD')
  }

  showCalculatorBtn(calculatorDiv: any) {
    this.showCalculator = !this.showCalculator;
    calculatorDiv.style.transform = this.showCalculator ? 'translate3d(0, 0, 0)' : 'translate3d(0, -550px, 0)';
  }

  validateInvoidesSat() {
    this.errorsValidateInvoices = []
    this.adminService.validateInvoices(this.formParent.controls['xml_list'].value).subscribe((response) => {
      if (response.error) {
        this.errorsValidateInvoices = response.list_errors
      } else {
        this.global.prepareAlert({ title: "Se validaron correctamente", message: 'no se encontro ningun error', label: "success" }).subscribe((result) => { });
      }
    });
  }

  deleteInvoicesError() {
    let uuidsMsg = '';
    for (let invoice of this.errorsValidateInvoices) {
      uuidsMsg += `${invoice.data.uuid}, `
    }
    this.global.prepareModal({ title: `Deseas eliminar las facturas invalidas?`, message: uuidsMsg }).subscribe(async (modalResult) => {
      if (modalResult == "ok") {
        let invalidUuids = []
        for (let invoiceSelected of this.errorsValidateInvoices) {
          invalidUuids.push(invoiceSelected.data.uuid);
        }
        this.deleteInvoicesV2(invalidUuids);
        this.errorsValidateInvoices = [];

      }
    })
  }

  deleteInvoicesV2(uuids: Array<any>) {
    let invalidUuids = uuids;
    this.selectedFiles = this.selectedFiles.filter(f => !invalidUuids.includes(f.uuid));
    this.xmlUuidFetched = this.xmlUuidFetched.filter(uuid => !invalidUuids.includes(uuid));
    this.arrayTypeCurrency = this.arrayTypeCurrency.filter((_, i) => !invalidUuids.includes(this.selectedFiles[i]?.uuid));
    this.invoicesData = this.invoicesData.filter(inv => !invalidUuids.includes(inv.uuid));

    // Filtrar también el FormArray
    let newFormArray = new UntypedFormArray([]);
    this.getXml.controls.forEach((ctrl, i) => {
      const uuid = ctrl.value.xml_uuid;
      if (!invalidUuids.includes(uuid)) {
        newFormArray.push(ctrl);
      }
    });
    this.formParent.setControl('xml_list', newFormArray);

    this.totalAmountBillings = Number(
      this.selectedFiles.reduce((init, invoice) => init + invoice.totalInvoice, 0).toFixed(2)
    );
  }

  recalculateExpirationDate(event: any) {
    this.valueExpirationDate = moment(event.value);
    this.showDate = this.valueExpirationDate.format('dddd, D [de] MMMM [de] YYYY')
    this.showDateFormat = this.valueExpirationDate.format('YYYY-MM-DD')
    this.showDateFormat += 'T18:00:00Z'
  }

  changeTab(tab: string) {
    this.selectTab = tab;
  }

  onChangeComission(){
    let drawdownFee = +(this.creditLineSelected.drawdown_fee * this.totalsOnInvoices.amount_preapproved).toFixed(3);
    let drawdownFeeVat = +(drawdownFee * 0.16).toFixed(3)
    this.totalsOnInvoices.amount_preapproved_with_commissions = this.totalsOnInvoices.amount_preapproved
    this.totalsOnInvoices.amount_preapproved_with_commissions = this.totalsOnInvoices.amount_preapproved - (drawdownFee + drawdownFeeVat);

    if(this.typeCurrency != 'MXN'){
        // this.totalsOnInvoices.amount_drawdown_fee = drawdownFee
        // this.totalsOnInvoices.amount_drawdown_fee_vat = +(this.totalsOnInvoices.amount_drawdown_fee * 0.16).toFixed(3);

        // this.totalsOnInvoices.amount_drawdown_fee = this.totalsOnInvoices.amount_drawdown_fee * this.exchangeRate.value;
        // this.totalsOnInvoices.amount_drawdown_fee_vat = this.totalsOnInvoices.amount_drawdown_fee_vat * this.exchangeRate.value;
        this.totalsOnInvoices.amount_preapproved_with_commissions = this.totalsOnInvoices.amount_preapproved_with_commissions * this.exchangeRate.value;
      }
    if(this.signingFeeCharge){
      this.totalsOnInvoices.amount_preapproved_with_commissions-=this.totalsOnInvoices.amount_signing_fee;
      this.totalsOnInvoices.amount_preapproved_with_commissions-=this.totalsOnInvoices.amount_signing_fee_vat;
    }
  }

  setPartner(partner:any){
    this.partnerSelected = partner;
    this.searchAccounts(this.partnerSelected.product_type, this.partnerSelected.code)
  }

  async verifyUuidsDatabase(){
    let invoicesData =  this.selectedFiles.map(file => ({
      uuid: file.uuid,
      name: file.name
    }));
    let result = await this.adminService.verifyInvoicesInDb(invoicesData).toPromise();
    if(!result.error){
      this.errorsValidateInvoicesDb = result.data
    }else{
      this.global.prepareAlert({ title: "Hubo un error", message: result.message, label: "error" }).subscribe((result) => { });
    }
  }
  async processInvalidInovicesDb(){
    if(this.errorsValidateInvoicesDb.length > 0){
      let uuids = this.errorsValidateInvoicesDb.map((item:any) => item.uuid);
      await this.deleteInvoicesV2(uuids)
      this.errorsValidateInvoicesDb = []
    }
  }
}
